// import
import { setAuthorization } from './authorization'
import axios from 'axios'

// export authLogin
export const authLogin = (credentials) => {
  const base_url = 'http://localhost:8000/auth/login'
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }
  }
  return new Promise((resolve, reject) => {
    axios.post(base_url, credentials, config)
    .then((response) => {
      setAuthorization(response.data.access_token)
      return resolve(response.data)
    }).catch((error) => {
      return reject(error.response.data.errors)
    })
  })
}

// export authLocalStorage
export const authLocalStorage = () => {
  const authUser = localStorage.getItem('user')
  return !authUser ? null : JSON.parse(authUser)
}
